import { Button, Col, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import EpaCard from "../../leap-components/EpaCard";

import useAppSelector from "../../hooks/useAppSelector";
import useAppDispatch from "../../hooks/useAppDispatch";

import {
  acceptTermsOfService,
  LegalCookieName,
  selectConfirm,
  toggleAcceptance,
} from "../../redux/slices/legal";
import { setCookie } from "../../cookies/cookies";

const ConfirmCard = () => {
  const confirm = useAppSelector(selectConfirm);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const returnUrl = urlParams.get("returnUrl");

  const Continue = () => {
    setCookie(LegalCookieName, "true", 1);
    dispatch(acceptTermsOfService());
    window.location.href = returnUrl ? returnUrl : ""; //try navigate with absolute path
  };

  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12">
          <p>
            LEAP provides access to application documentation and formal
            compliance and enforcement correspondence¹ exchanged between the
            EPA, applicants, and regulated operators across the following
            activity areas:
          </p>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col className="col-12 col-md-6">
          <ul style={{ listStyleType: "square" }}>
            <li>Circular Economy Regulation (By-Product and End-of-Waste)</li>
            <li>Certificates of Registration (issued to Local Authorities)</li>
            <li>Dumping at Sea</li>
            <li>Greenhouse Gas Permits (GHG)</li>
            <li>Historic Landfills</li>
            <li>
              Industrial Activities: Industrial Emissions (IE), Integrated
              Pollution Prevention & Control (IPPC), Integrated Pollution
              Control (IPC)
            </li>
          </ul>
        </Col>
        <Col className="col-12 col-md-6">
          <ul style={{ listStyleType: "square" }}>
            <li>Medium Combustion Plant Registrations</li>
            <li>Radiological Protection</li>
            <li>
              Urban Waste Water Discharge: Waste Water Discharge Authorisations
              (WWDA) and Certificates of Authorisation (CoA)
            </li>
            <li>Volatile Organic Compounds (VOC)</li>
            <li>Waste Management</li>
            <li>Water Abstractions</li>
          </ul>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col className="col-12">
          <p>
            LEAP allows you to view details of applications, licences, and
            permits issued by the EPA. It also includes records related to the
            regulation of licensed and permitted sites, such as EPA site
            inspection and monitoring reports, licensee returns, incidents,
            non-compliances, complaints, and compliance investigations¹.
          </p>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col className="col-12">
          <a
            style={{ fontWeight: "bold" }}
            target="_blank"
            href="https://www.epa.ie/our-services/compliance--enforcement/whats-happening/leap-online"
          >
            Find more about LEAP
          </a>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col className="col-12">
          <small>
            <p>
              ¹
              <a
                target="_blank"
                href="https://www.epa.ie/publications/compliance--enforcement/licensees/performance/epa-guidance-note-on-leap-online-public-access-portal-v20-may-2023.php"
              >
                special rules
              </a>{" "}
              apply to Greenhouse Gas Permitting whereby only the permit is
              accessible
            </p>
          </small>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col>
          <p style={{ fontWeight: "bold" }}>
            To continue, please confirm that you have read and agree to the{" "}
            <a
              style={{ fontWeight: "bold" }}
              target="_blank"
              href="https://www.epa.ie/publications/compliance--enforcement/licensees/performance/terms-and-conditions-for-using-leap.php"
            >
              Terms and Conditions
            </a>{" "}
            for using the LEAP Portal.
          </p>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col className="col-12">
          <input
            type="checkbox"
            checked={confirm}
            onChange={() => dispatch(toggleAcceptance())}
          />
          <span style={{ paddingLeft: "0.5rem" }}>I Confirm</span>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col className="col-12">
          <Button disabled={!confirm} onClick={() => Continue()}>
            Continue
          </Button>
        </Col>
      </Row>
    </div>
  );

  return (
    <EpaCard
      title={"Welcome to LEAP, the EPA's Licence and Enforcement Access Portal"}
      content={bodyElements}
    />
  );
};

export default ConfirmCard;
